/*!
 * Copyright © 2026. Verizon Connect Ireland Limited. All rights reserved.
 */

export enum EManagePostedSpeedTabs {
  Update,
  EditDelete
}
